module.exports = "./img/6c1c46130f54ec49fa7cd8a63e873f7f.jpg";